var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({staticClass:"nitrozen-inline-svg",domProps:{"innerHTML":_vm._s(_vm.getSVG)}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }